<template>
  <li>
    <a
      v-if="!appInfo.additionalUrls"
      itemprop="url"
      :href="appUrl">
      {{ title }}
    </a>
    <a
      v-else
      itemprop="url"
      href="#"
      @click.prevent="expanded = !expanded">
      {{ title }}
    </a>
    <transition name="fade">
    <ul class="mobile-nav_second" v-if="appInfo.additionalUrls && expanded">
      <li>
        <a
          itemprop="url"
          :href="appUrl">
          {{ title }}
        </a>
      </li>
      <li
        v-for="(add, index) of appInfo.additionalUrls"
        :key="index">
        <a
          itemprop="url"
          :href="appUrl+`/${add.url}`">
          {{ $t(add.headerTitleMobileT) }}
        </a>
      </li>
    </ul>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'LandingHeaderMobileItem',
  props: {
    appInfo: { type: Object },
    title: { type: String },
    locale: { type: String }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    appUrl () {
      return `/${this.locale}/${this.appInfo.url}`
    }
  },
  methods: {
    onClick () {
      this.expanded = true
    },
    isAdditionalActive (pagePath) {
      const currentUrl = new URL(window.location.href)
      const path = currentUrl.pathname
      return path === pagePath
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    opacity: 1;
    max-height: fit-content;
    transition: all 200ms linear;
    will-change: opacity, max-height;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: opacity 200ms linear, max-height 200ms linear;
    will-change: opacity, max-height;
  }
</style>
